import React, { FC, ReactNode } from 'react';
import { CoreActionButton, CoreActionButtonProps } from './core-action-button.component';
import { CoreActionsRow } from './core-actions-row.component';
import CoreTableActionMenu, { CoreTableActionMenuProps } from './core-table-action-menu.component';
import { Tooltip } from '@mui/material';

interface ReactNodeAction {
	type: 'react-node';
	node?: ReactNode;
	hidden?: boolean;
}

interface ButtonAction {
	type: 'button';
	props?: CoreActionButtonProps;
	tooltipTitle?: string;
}

interface MenuAction {
	type: 'menu';
	hidden?: boolean;
	props?: CoreTableActionMenuProps;
}

export type CellAction = (MenuAction | ButtonAction | ReactNodeAction) & { id: string };

interface CoreTableActionsCellProps {
	actions: CellAction[];
}

export const CoreTableActionsCell: FC<CoreTableActionsCellProps> = (props) => {
	const { actions } = props;

	const renderAction = (action: CellAction) => {
		if (action.type === 'button') {
			const button = <CoreActionButton key={action.id} sx={{ width: 32, height: 32 }} {...action.props} />;

			return !action.props?.hidden ? (
				<Tooltip title={action.tooltipTitle} key={action.id}>
					{button}
				</Tooltip>
			) : null;
		}

		if (action.type === 'menu') {
			return action.hidden ? null : <CoreTableActionMenu key={action.id} {...action.props} />;
		}

		if (action.type === 'react-node') {
			return action.node;
		}

		return null;
	};

	return <CoreActionsRow>{actions.map(renderAction)}</CoreActionsRow>;
};
